import { render, staticRenderFns } from "./AprovarDadoModal.vue?vue&type=template&id=716fa748&scoped=true"
import script from "./AprovarDadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AprovarDadoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716fa748",
  null
  
)

export default component.exports